import React, { useEffect } from "react";
import { useData } from "../util/dataProvider";
import { useParams, useNavigate } from "react-router-dom";
import { storage } from "../util/firebase";
import useImageUrl from "./Image";
import Close from "../images/close.svg";
import placeholder from "../images/experten_placeholder.jpg";
import user_placeholder from '../images/user_placeholder.png';
export default function Expert() {
    const { experten, getColor, assetUrl } = useData();
    const { expertid } = useParams();
    const sc = experten.find((expert) => expert.id === expertid);
    const headerPic = useImageUrl(sc?.header);
    const profilePic = useImageUrl(sc?.image);

    const navigate = useNavigate();
    useEffect(() => {
        let menu = document.getElementById("hamburger");
        if (menu) {
            menu.style.opacity = "0";
        }
    }, []);
    if (!sc) {
        return <div>Der Experte konnte nicht gefunden werden.</div>;
    }
    return (
        <div className='single-company'>
            <img
                className='close'
                src={assetUrl + Close}
                onClick={() => navigate("/")}
            />{" "}
            <div
                className='header-image'
                style={{
                    backgroundImage: headerPic
                        ? `url(${headerPic})`
                        : `url(${assetUrl + placeholder})`,
                }}></div>
            <div
                className='header-information'
                style={{ backgroundColor: getColor(sc.category) }}>
                <div className='left'>
                    <div className='cat'>{sc.employees}</div>
                    <div className='name'>
                        {sc.firstname} {sc.lastname}
                    </div>
                </div>
                {sc.description &&
                <div className='right'>
                    <h3>short story</h3>
                    <div className='desc'>{sc.description}</div>
                </div>
}
            </div>
           
            <div className='additional-information'>
                <div className='left'>
                    <h3> {sc.gender == "Männlich" ? "Experte" : "Expertin"}</h3>
                    <p>
                        {sc.firstname} {sc.lastname}
                        <br />
                        {sc.long_name}
                        <br />
                        {sc.street_number}
                        <br />
                        {sc.zip} {sc.city}
                        <br />
                    </p>
                    <p>
                        Tel: {sc.phone}
                        <br />
                        {sc.email}
                    </p>{" "}
                    <h3 className='margin-top-light margin-bottom-light'>
                        {" "}
                        Schwerpunkte
                    </h3>
                    {sc.fields &&
                        sc.fields.map((field, idx) => {
                            return <div key={idx}>/ {field}</div>;
                        })}
                    <h3
                        style={{ marginTop: "4rem" }}
                        className=' margin-bottom-light'>
                        Interesse an
                    </h3>
                    {sc.interested &&
                        sc.interested.map((interest, idx) => {
                            return <div key={idx}>/ {interest}</div>;
                        })}
                </div>
                <div className='right'>
                    <div
                        style={{
                            backgroundSize: "contain",
                            minHeight: "50vh",
                            backgroundPosition: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundImage: profilePic ? `url(${profilePic})` : `url(${assetUrl + user_placeholder})`
                        }}></div>
                </div>
            </div>
        </div>
    );
}
